/* Native Shopify search. Query only on interaction; never download the catalogue. */
(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  const fields = 'title,body,product_type,tag,variants.title,variants.sku,variants.barcode,vendor';
  const cache = new Map();
  // Restrict recognisable buying intent before full-detail matching. Never treat litres as inches.
  const intentQuery = term => {
    const q=term.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
    if(/[():]/.test(q))return term;
    const laptop=/laptop|ordinateur|notebook|laptoptas/.test(q);
    const size=q.match(/\b(\d{2}(?:[.,]\d)?)\s*(?:inch(?:es)?|pouces?|zoll|["″])/);
    if(laptop&&size)return '(product_type:"Canvas Laptop Backpacks" OR product_type:"Leather Laptop Backpacks" OR product_type:"Canvas Backpacks" OR product_type:"Canvas Briefcases" OR product_type:"Leather Laptop Sleeves")';
    let types=[],rest=q;
    if(/boek(?:en)?hoes|book\s+(?:sleeve|cover)|buchhulle|buchschutz|(?:housse|pochette|protege)[ -]*(?:pour[ -]*)?(?:de[ -]*)?livre/.test(q)){
      types=['Book Sleeves','Book & Journal Covers'];rest=q.replace(/boek(?:en)?hoe(?:s|zen)|book\s+(?:sleeves?|covers?)|buchhullen?|buchschutz|(?:housse|pochette|protege)[ -]*(?:pour[ -]*)?(?:de[ -]*)?livres?/g,'');
    }else if(/camera|appareil photo|foto(?:tas|rucksack)|kameratas/.test(q)){
      types=['Camera Backpacks','Camera Shoulder Bags'];rest=q.replace(/camera|appareil photo|foto(?:tasche|rucksack)|kamera(?:tasche|tas)|bags?|sacs?|rucksack|backpacks?/g,'');
    }else if(laptop){
      const backpack=/backpack|rucksack|rugzak|sac a dos/.test(q),leather=/leather|leder|cuir|leer/.test(q);
      types=backpack?['Canvas Laptop Backpacks','Leather Laptop Backpacks']:['Canvas Laptop Backpacks','Leather Laptop Backpacks','Canvas Briefcases','Leather Laptop Sleeves'];
      if(leather)types=types.filter(v=>v.startsWith('Leather'));
      rest=q.replace(/sac a dos|laptop(?:tasche|tas)?|ordinateur|notebook|leather|leder|cuir|leer|bags?|sacs?|rucksack|rugzak|backpacks?|tasche/g,'');
    }
    if(!types.length)return term;
    rest=rest.replace(/\b(?:a|de|des|un|une|pour|for|with|mit|aus|en|van|met|the|een)\b/g,' ').replace(/[^\p{L}\p{N} .-]/gu,' ').replace(/\s+/g,' ').trim();
    const query='('+types.map(type=>'product_type:"'+type+'"').join(' OR ')+')';
    return query+(types.includes('Book Sleeves')?' AND -title:"e-reader"':'')+(rest?' AND '+rest:'');
  };
  const fitFilter=term=>{const q=term.toLowerCase(),m=q.match(/\b(\d{2}(?:[.,]\d)?)\s*(?:inch(?:es)?|pouces?|zoll|["″])/);return /laptop|ordinateur|notebook|laptoptas/.test(q)&&m?'Up to '+m[1].replace(',','.')+' inches':null;};
  window.DiyionSearchIntent=intentQuery;
  const fitParam=new URL(location.href).searchParams.get('filter.p.m.diyion_filters.laptop_size');
  if(fitParam&&document.querySelector('.c-search-page')){const note=document.createElement('p');note.className='dy-fit-search-note';note.textContent=({fr:'La recherche utilise la taille d’ordinateur indiquée dans les caractéristiques. Le volume du sac en litres ne définit pas la taille d’écran compatible.',de:'Die Suche berücksichtigt die angegebene Laptopgröße. Das Volumen in Litern sagt nichts über die passende Bildschirmgröße aus.',nl:'De zoekresultaten gebruiken de opgegeven laptopmaat. De inhoud in liters zegt niets over de geschikte schermmaat.',en:'Results use the stated laptop size. Bag capacity in litres does not indicate the screen size that fits.'})[document.documentElement.lang.slice(0,2)]||'';document.querySelector('.c-search-summary')?.after(note);}
  const originalTerm=new URL(location.href).searchParams.get('dyq');
  if(originalTerm){document.querySelectorAll('[data-search-original]').forEach(e=>e.textContent=originalTerm);document.querySelectorAll('[data-search-input]').forEach(e=>e.value=originalTerm);}
  document.querySelectorAll('[data-product-search]').forEach(host => {
    const form = host.querySelector('form');
    const input = host.querySelector('[data-search-input]');
    const popup = host.querySelector('[data-search-popup]');
    const list = host.querySelector('[data-search-list]');
    const idle = host.querySelector('[data-search-idle]');
    const message = host.querySelector('[data-search-message]');
    const all = host.querySelector('[data-search-all]');
    const clear = host.querySelector('[data-search-clear]');
    const announcer = host.querySelector('[data-search-announcer]');
    const strings = JSON.parse(host.querySelector('[data-search-strings]').textContent);
    let debounce, controller, serial = 0, active = -1;
    const query = () => input.value.trim().replace(/\s+/g, ' ');
    const options = () => [...list.querySelectorAll('[data-search-option]')];
    const resetSelection = () => {
      active = -1;
      input.removeAttribute('aria-activedescendant');
      options().forEach(option => option.setAttribute('aria-selected', 'false'));
    };
    const sizePopup = () => {
      const viewport = window.visualViewport;
      const bottom = (viewport?.offsetTop || 0) + (viewport?.height || innerHeight);
      const space = Math.max(130, bottom - host.getBoundingClientRect().bottom - 12);
      popup.style.setProperty('--search-space', `${Math.min(570, space)}px`);
    };
    const show = () => {
      popup.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      sizePopup();
    };
    const cancel = () => {
      clearTimeout(debounce);
      controller?.abort();
      controller = null;
      serial++;
      host.removeAttribute('aria-busy');
    };
    const close = () => {
      cancel();
      popup.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      resetSelection();
    };
    const fullUrl = () => {
      const url = new URL(form.action, location.origin);
      const refined=intentQuery(query());
      url.searchParams.set('q', refined);if(refined!==query())url.searchParams.set('dyq',query());const fit=fitFilter(query());if(fit)url.searchParams.set('filter.p.m.diyion_filters.laptop_size',fit);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('options[unavailable_products]', 'last');
      return url.href;
    };
    const display = markup => {
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const response = doc.querySelector('[data-search-response]');
      if (!response) throw Error('Search response unavailable');
      const items = [...response.querySelectorAll('[data-search-option]')];
      items.forEach((item, index) => {
        item.id = `${input.id}Option${index}`;
        const link = item.querySelector('a');
        link.href = new URL(link.getAttribute('href'), location.origin).href;
      });
      list.replaceChildren(...items);
      list.hidden = !items.length;
      idle.hidden = true;
      message.textContent = items.length ? '' : strings.empty;
      message.hidden = Boolean(items.length);
      all.href = fullUrl();
      all.hidden = false;
      host.removeAttribute('aria-busy');
      resetSelection();
      announcer.textContent = items.length ? strings.count.replace('{count}', items.length) : strings.empty;
      show();
    };
    const lookup = async () => {
      const term = query();
      if (term.length < 2) return;
      const ticket = serial;
      const key = `${root}|${term.toLocaleLowerCase()}`;
      try {
        if (cache.has(key)) { display(cache.get(key)); return; }
        controller = new AbortController();
        const currentController = controller;
        const timeout = setTimeout(() => currentController.abort(), 6000);
        const refined=intentQuery(term),intent=refined!==term;
        const url = new URL(root + (intent?'search':'search/suggest'), location.origin);
        url.searchParams.set('q', refined);if(intent)url.searchParams.set('type','product');const fit=fitFilter(term);if(fit)url.searchParams.set('filter.p.m.diyion_filters.laptop_size',fit);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[options][fields]', fields);
        url.searchParams.set('section_id', intent?'reader-intent-search':'reader-predictive-search');
        let markup;
        try {
          const response = await fetch(url, {credentials: 'same-origin', signal: currentController.signal, headers: {Accept: 'text/html'}});
          if (!response.ok) throw Error('Search response unavailable');
          markup = await response.text();
        } finally { clearTimeout(timeout); }
        if (ticket !== serial || query() !== term || popup.hidden) return;
        display(markup);
        cache.set(key, markup);
        if (cache.size > 20) cache.delete(cache.keys().next().value);
      } catch {
        if (ticket !== serial || popup.hidden) return;
        host.removeAttribute('aria-busy');
        list.hidden = true;
        message.hidden = false;
        message.textContent = strings.unavailable;
        announcer.textContent = strings.unavailable;
        all.href = fullUrl();
        all.hidden = false;
      }
    };
    const update = () => {
      cancel();
      resetSelection();
      clear.hidden = !input.value;
      list.hidden = true;
      list.replaceChildren();
      all.hidden = true;
      message.hidden = true;
      idle.hidden = query().length >= 2;
      announcer.textContent = '';
      show();
      if (query().length < 2) return;
      all.href = fullUrl();
      all.hidden = false;
      message.textContent = strings.loading;
      message.hidden = false;
      host.setAttribute('aria-busy', 'true');
      debounce = setTimeout(lookup, 200);
    };
    input.addEventListener('input', event => { if (!event.isComposing) update(); });
    input.addEventListener('compositionend', update);
    input.addEventListener('focus', update);
    input.addEventListener('click', () => { if (popup.hidden) update(); });
    input.addEventListener('keydown', event => {
      if (event.isComposing) return;
      if (event.key === 'Escape' && !popup.hidden) { event.preventDefault(); close(); return; }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const items = options();
        if (!items.length || list.hidden) return;
        event.preventDefault();
        show();
        active = event.key === 'ArrowDown' ? (active + 1) % items.length : (active < 0 ? items.length - 1 : (active - 1 + items.length) % items.length);
        items.forEach((item, index) => item.setAttribute('aria-selected', String(index === active)));
        input.setAttribute('aria-activedescendant', items[active].id);
        items[active].scrollIntoView({block: 'nearest'});
      } else if (event.key === 'Enter' && active >= 0 && !popup.hidden) {
        event.preventDefault();
        options()[active].querySelector('a').click();
      }
    });
    clear.addEventListener('click', () => { input.value = ''; input.focus(); update(); });
    host.querySelectorAll('[data-search-idea]').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      input.value = link.dataset.searchIdea;
      input.focus();
      update();
    }));
    form.addEventListener('submit', event => {
      if (!query()) { event.preventDefault(); input.focus(); update(); return; }
      event.preventDefault();location.assign(fullUrl());
    });
    host.addEventListener('focusout', () => setTimeout(() => { if (!host.contains(document.activeElement)) close(); }, 0));
    document.addEventListener('pointerdown', event => { if (!host.contains(event.target)) close(); });
    addEventListener('resize', sizePopup, {passive: true});
    window.visualViewport?.addEventListener('resize', sizePopup, {passive: true});
    addEventListener('pagehide', cancel);
    clear.hidden = !input.value;
    host.dataset.searchReady = 'true';
  });
})();
